<template>
  <div class="card-body">

    <button class="btn btn-success btn-icon text-white fw-bolder btn-icon-text float-end" @click="showForm()"
      type="button"> <i class="mdi mdi-folder-plus"></i> </button>

    <br>
    <br>
    <br>

    <vue-good-table title="list-barang-impor" :totalRows="totalRecords" :rows="rowsBarang" :columns="columnsBarang"
      :line-numbers="true">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'actions'">

          <a href="#" v-if="forms.status != 'FINISH'" title="Copy" @click.prevent="copyDataBarang(props.row)">
            <i class="mdi mdi-content-copy" style="font-size:16px;color:#5660d9;"></i>
          </a>

          <a href="#" v-if="forms.status != 'FINISH'" title="Edit" @click.prevent="editDataBarang(props.row)">
            <i class="mdi mdi-square-edit-outline" style="font-size:16px;color:#66d1d1;"></i>
          </a>


          <a href="#" v-if="forms.status != 'FINISH'" title="Delete" @click.prevent="deleteDataBarang(props.row)">
            <i class="mdi mdi-delete-forever" style="font-size:16px;color:red;"></i>

          </a>
        </span>

        <span v-else-if="props.column.field == 'jenis_satuan'">
          {{ props.row.kodeSatuanBarang }} - {{ props.row.namaSatuanBarang }}
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>

  </div>
</template>

<script>
export default {
  name: "CeisaBarangTable",
  components: {},
  data() {
    return {
      forms: [],
      totalRecords: 0,
      docSeriNo: 0,
      rowsBarang: [],
      columnsBarang: [
        {
          label: "HS",
          field: 'hsCode',
          thClass: 'text-center',
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t('uraian_txt'),
          field: 'uraian',
          thClass: 'text-center',
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t('nilai_barang'),
          field: 'nilaiBarang',
          thClass: 'text-center',
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t('jumlah_satuan'),
          field: 'jumlahSatuan',
          thClass: 'text-center',
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t('jenis_satuan'),
          field: 'jenis_satuan',
          thClass: 'text-center',
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: 'text-center',
          sortable: false,
          filterOptions: {
            customFilter: false,
          }
        },
      ],

    }
  },
  methods: {
    editDataBarang(ev) {
      this.$emit("showForm", ev,"update");
    },
    copyDataBarang(ev){
      this.$emit("showForm", ev,"copy");
    },
    showForm() {
      this.$emit("showForm", null);
    },
    deleteDataBarang(row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-8-delete-barang/" + row.document_id + "/" + row.document_barang_id;

          return this.$http
            .delete(
              baseURI, { timeout: 10000 }
            )
            .then((response) => {
              console.log(response);
              if (response.data.status === 200) {
                this.errors = [];
                this.success("Data Berhasil Dihapus")
                this.$emit("deleteBarang");
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch(error => {

              if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
              }else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

            });
        } else {
          this.isLoading = false;
        }
      });
    },
    reAssignValue() {
      this.rowsBarang = this.forms.barang;
    },
    error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;

            let rolePermision = [];

            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaBarangImporController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

            this.loadFilterType();
            this.loading();

        },


        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
  },
  created() { },
  props: {
    propsData: { type: [Object, Array] }
  },
  watch: {
    propsData: function (newVal) {
      this.forms = newVal;
      console.log(newVal);
      this.reAssignValue();

    },
    forms: function (newVal) {
      this.$emit('formUpdate', newVal);
    },
  },
}
</script>

<style></style>